import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import {RadioGroupFormsy} from '@fuse';
import { Paper, Grid, Divider, TextField, FormControlLabel, Card, CardContent, Radio, CardHeader } from '@material-ui/core';
// import Formsy from 'formsy-react';
// import _ from '@lodash';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';

// import HomeIcon from '@material-ui/icons/Home';
// import EditIcon from '@material-ui/icons/Edit';
// import DeleteIcon from '@material-ui/icons/Delete';
// import AddIcon from '@material-ui/icons/Add';
// import CompareIcon from '@material-ui/icons/CompareArrows';
// import ListAltSharpIcon from '@material-ui/icons/List';
// import MenuIcon from '@material-ui/icons/Menu';
// import SaveIcon from '@material-ui/icons/Save';
// import CloseIcon from '@material-ui/icons/Close';
// import ArrowBackIcon from '@material-ui/icons/ArrowBackIosSharp';
// import ArrowForwardIcon from '@material-ui/icons/ArrowForwardIosSharp';

const styles = theme => ({
    layoutRoot: {},
    panelPertanyaan: {
        marginBottom: 10
    },
    judulPertanyaan: {
        fontSize: '17px',
        color: '#007AFF'
    },
    poinPilihan: {
        boxShadow: '0px 0px',
        borderRadius: 0,
        border: '0px solid #ccc',
        padding: 0
    },
    judulSubSub: {
        fontSize: '14px',
        color: '#ffffff'
    },
    kontenJudulSubSub: {
        background: '#AAAAAA',
        padding: 10
    },
    kontenSubSub: {
        padding: 10
    },
    borders: {
        border: '0px solid #ccc'
    },
    kunci_konfirmasi_instrumen: false,
    panelPengawas: {
        background: '#eeeeee'
    }
});

class PanelPertanyaan extends Component {
    state = {
        error: false,
        checkSelect: {},
        checkRadio: [],
        isian: {}
    }

    checkboxTerpilih = (ins_instrumen_id, induk_kode, abstain) => (event, checked) => {
        console.log(abstain);
        console.log(ins_instrumen_id);
        // console.log(event.target);
        // console.log(this.props.kuesioner);
        // event.persist();
        if(Number(abstain) === 1){
            // alert('tidak memilih semua jawaban');return false;
            // for (let indexKuesioner = 0; indexKuesioner < this.props.kuesioner.rows.length; indexKuesioner++) {
            //     const element = this.props.kuesioner.rows[indexKuesioner];

            //     if(element.ins_instrumen_id === ins_instrumen_id){

            //     }
                
            // }
            if(checked){

                this.props.kuesioner.rows.map((option)=>{
                    console.log(option.ins_instrumen_id + " - " + ins_instrumen_id);
                    if(option.ins_instrumen_id === ins_instrumen_id){
                        option.nilai = 0;
                        option.dirty = 1;
                    }
    
                    return option;
                });
    
                // console.log(this.props.kuesioner);
            }

            this.props.setKuesioner(this.props.kuesioner);
        }else{
            if(checked){
                this.props.kuesioner.rows.map((option)=>{
                    //custom for abstain checkbox
                    if(option.ins_instrumen_id === ins_instrumen_id && Number(option.abstain) === 1){
                        option.nilai = 0;
                        option.dirty = 1;
                    }
                    return option;
                });
            }
        }

        this.setState({
            ...this.state,
            checkSelect: {
                ...this.state.checkSelect,
                [event.currentTarget.name] : !this.state.checkSelect[event.currentTarget.name]
            }
        });

        // for (let index = 0; index < this.props.kuesioner.rows.length; index++) {
        //     const element = this.props.kuesioner.rows[index];
            
        //     if(element.instrumen_id === event.currentTarget.name){
        //         this.props.kuesioner.rows.splice(index, 1);
        //     }
            
        // }

        let nilai = 1;
        
        if(checked){
            // do nothin    
        }else{
            nilai = 0;
        }

        if(typeof this.props.kuesioner.rows.find(x => x.instrumen_id === event.currentTarget.name) !== 'undefined'){
            this.props.kuesioner.rows.find(x => x.instrumen_id === event.currentTarget.name).nilai = nilai;
            this.props.kuesioner.rows.find(x => x.instrumen_id === event.currentTarget.name).dirty = 1;
            console.log(this.props.kuesioner.rows.find(x => x.instrumen_id === event.currentTarget.name));
        }else{
            
            let jawaban = {};
            jawaban.ins_instrumen_id = ins_instrumen_id;
            jawaban.induk_kode = this.props.location.pathname.split('/')[2];
            jawaban.instrumen_id = event.currentTarget.name;
            jawaban.dirty = 1;
            jawaban.tipe_instrumen_id = 2;
            jawaban.pengguna_id = JSON.parse(localStorage.getItem('user')).pengguna_id;
            jawaban.nilai = nilai;
            jawaban.abstain = abstain;
        
            this.props.kuesioner.rows.push(jawaban);
            this.props.kuesioner.total = this.props.kuesioner.rows.length;
            console.log(jawaban);
        }
        console.log(this.props.kuesioner.rows);
        // this.props.kuesioner.dirty = 1;
        this.props.setKuesioner(this.props.kuesioner);
        this.props.setKuesionerDirty(1);
    }

    radioTerpilih = (event) => {
        let jawaban = {};
        jawaban.ins_instrumen_id = event.currentTarget.name;
        jawaban.instrumen_id = event.currentTarget.value;
        jawaban.dirty = 1;
        jawaban.tipe_instrumen_id = 3;
        jawaban.pengguna_id = JSON.parse(localStorage.getItem('user')).pengguna_id;
        jawaban.induk_kode = this.props.location.pathname.split('/')[2];
        jawaban.nilai = 1;

        for (let index = 0; index < this.props.kuesioner.rows.length; index++) {
            const element = this.props.kuesioner.rows[index];

            if(element.ins_instrumen_id === event.currentTarget.name){
                // this.props.kuesioner.rows.splice(index, 1);
                this.props.kuesioner.rows[index].nilai = 0;
                this.props.kuesioner.rows[index].dirty = 1;
            }
            
            if(element.instrumen_id === event.currentTarget.value){
                this.props.kuesioner.rows.splice(index, 1);
                // this.props.kuesioner.rows[index].nilai = 0;
            }
            
        }

        this.props.kuesioner.rows.push(jawaban);
        this.props.kuesioner.total = this.props.kuesioner.rows.length;

        this.props.setKuesioner(this.props.kuesioner);
        this.props.setKuesionerDirty(1);

        // console.log(this.props.kuesioner);
    }

    handleChange = (name, instrumen_id, ins_instrumen_id) => event => {
        const re = /^[0-9\b]+$/;
        // console.log(this.state.checkSelect[instrumen_id]);
        if (re.test(event.target.value) === true || event.target.value === '') {
            // this.props.kuesioner.rows.map((option)=>{
            //     //custom for abstain checkbox
            //     if(option.ins_instrumen_id === ins_instrumen_id && Number(option.abstain) === 1){
            //         option.nilai = 0;
            //         option.dirty = 1;
            //     }
            //     return option;
            // });

            // this.setState({
            //     ...this.state,
            //     checkSelect: {
            //         ...this.state.checkSelect,
            //         [event.currentTarget.name] : !this.state.checkSelect[event.currentTarget.name]
            //     }
            // });
            
            // this.setState({
            //     ...this.state,
            //     isian: {
            //         ...this.state.isian,
            //         // nilai: 1,
            //         [name]: event.target.value,
            //     },
            //     checkSelect: {
            //         ...this.state.checkSelect,
            //         [instrumen_id] : !this.state.checkSelect[instrumen_id]
            //     }
            // }, ()=>{
            //     // console.log(this.state[name]);
            // });

            // let nilai = 1;

            // if(typeof this.props.kuesioner.rows.find(x => x.instrumen_id === instrumen_id) !== 'undefined'){
            //     this.props.kuesioner.rows.find(x => x.instrumen_id === instrumen_id).nilai = nilai;
            //     this.props.kuesioner.rows.find(x => x.instrumen_id === instrumen_id).isian = event.target.value;
            //     this.props.kuesioner.rows.find(x => x.instrumen_id === instrumen_id).dirty = 1;
            //     console.log(this.props.kuesioner.rows.find(x => x.instrumen_id === instrumen_id));
            // }else{
                
            // //     let jawaban = {};
            // //     jawaban.ins_instrumen_id = ins_instrumen_id;
            // //     jawaban.induk_kode = this.props.location.pathname.split('/')[2];
            // //     jawaban.instrumen_id = event.currentTarget.name;
            // //     jawaban.dirty = 1;
            // //     jawaban.tipe_instrumen_id = 2;
            // //     jawaban.pengguna_id = JSON.parse(localStorage.getItem('user')).pengguna_id;
            // //     jawaban.nilai = nilai;
            // //     jawaban.abstain = 0;
            
            // //     this.props.kuesioner.rows.push(jawaban);
            // //     this.props.kuesioner.total = this.props.kuesioner.rows.length;
            // //     // console.log(jawaban);
            // }
            // // console.log(this.props.kuesioner.rows);
            // // this.props.kuesioner.dirty = 1;
            // this.props.setKuesioner(this.props.kuesioner);
            // this.props.setKuesionerDirty(1);

            if(typeof this.props.kuesioner.rows.find(x => x.instrumen_id === instrumen_id) !== 'undefined'){
                this.props.kuesioner.rows.find(x => x.instrumen_id === instrumen_id).nilai = 1;
                this.props.kuesioner.rows.find(x => x.instrumen_id === instrumen_id).dirty = 1;
                this.props.kuesioner.rows.find(x => x.instrumen_id === instrumen_id).isian = event.target.value;
                console.log(this.props.kuesioner.rows.find(x => x.instrumen_id === instrumen_id));
            }else{
                
                let jawaban = {};
                jawaban.ins_instrumen_id = ins_instrumen_id;
                jawaban.induk_kode = this.props.location.pathname.split('/')[2];
                jawaban.instrumen_id = instrumen_id;
                jawaban.dirty = 1;
                jawaban.tipe_instrumen_id = 2;
                jawaban.pengguna_id = JSON.parse(localStorage.getItem('user')).pengguna_id;
                jawaban.nilai = 1;
                jawaban.abstain = 0;
            
                this.props.kuesioner.rows.push(jawaban);
                this.props.kuesioner.total = this.props.kuesioner.rows.length;
                console.log(jawaban);
            }
            console.log(this.props.kuesioner.rows);
            // this.props.kuesioner.dirty = 1;
            this.props.setKuesioner(this.props.kuesioner);
            this.props.setKuesionerDirty(1);

        }else{
            alert('hanya boleh diisi dengan angka/tidak lebih dari 100!');
            this.setState({
                ...this.state,
                [name]: '',
            }, ()=>{
                // console.log(this.state[name]);
            });
        }

    };

    componentDidMount = () => {
        this.setState({
            ...this.state,
            checkSelect: {
                ...this.state.checkSelect,
                "123" : true
            }
        });
        // console.log(this.props);
        // let tmpIsian = {};

        

        if (typeof this.props.poinPertanyaan.children === 'undefined') {
            
            // for (let index = 0; index < this.props.poinPertanyaan.rows.length; index++) {
            //     const element = this.props.poinPertanyaan.rows[index];
            //     this.state.isian['isian_'+element.instrumen_id] = element.isian;
    
            // }
        }else{

            for (let index = 0; index < this.props.poinPertanyaan.children.rows.length; index++) {
                const element = this.props.poinPertanyaan.children.rows[index];
                // console.log(element.isian);
                // tmpIsian['isian_'+element.instrumen_id] = element.isian;
                // console.log(element.a_pertanyaan);
                if(typeof element.children === 'undefined'){
                    // this.state.isian['isian_'+element.instrumen_id] = element.isian;
                    this.setState({
                        isian: {
                            ...this.state.isian,
                            ['isian_'+element.instrumen_id]: element.isian
                        }
                    });

                    if(this.props.konfirmasi_instrumen_id === null){
                        if(element.isian !== null && element.isian !== ''){
                            // this.state.isian['disabled_'+element.instrumen_id] = false;
                            this.setState({
                                isian: {
                                    ...this.state.isian,
                                    ['disabled_'+element.instrumen_id]: false
                                }
                            })
                        }else{
                            // this.state.isian['disabled_'+element.instrumen_id] = true;
                            this.setState({
                                isian: {
                                    ...this.state.isian,
                                    ['disabled_'+element.instrumen_id]: true
                                }
                            })
                        }
                    }

                }else{
                    //ternyata ada sub nya juga
                    // console.log(element);
                    for (let indexSubIsian = 0; indexSubIsian < element.children.rows.length; indexSubIsian++) {
                        const elementSubIsian = element.children.rows[indexSubIsian];
                        // console.log(elementSubIsian);
                        // this.state.isian['isian_'+elementSubIsian.instrumen_id] = elementSubIsian.isian;
                        this.setState({
                            isian: {
                                ...this.state.isian,
                                ['isian_'+elementSubIsian.instrumen_id]: elementSubIsian.isian
                            }
                        });
                        if(this.props.konfirmasi_instrumen_id === null){
                            if(elementSubIsian.isian !== null && elementSubIsian.isian !== ''){
                                // this.state.isian['disabled_'+elementSubIsian.instrumen_id] = false;
                                this.setState({
                                    isian: {
                                        ...this.state.isian,
                                        ['disabled_'+elementSubIsian.instrumen_id]: false
                                    }
                                })
                            }else{
                                // this.state.isian['disabled_'+elementSubIsian.instrumen_id] = true;
                                this.setState({
                                    isian: {
                                        ...this.state.isian,
                                        ['disabled_'+elementSubIsian.instrumen_id]: true
                                    }
                                })
                            }
                        }
                    }
                }
        //         let jawaban = {};
        //         // jawaban.ins_instrumen_id = event.currentTarget.ins_instrumen_id;
        //         // jawaban.induk_kode = event.currentTarget.induk_kode;
    
        //         if(this.props.poinPertanyaan.children.rows.jawaban_id){
        //             jawaban.jawaban_id = this.props.poinPertanyaan.children.rows.jawaban_id;
        //             jawaban.instrumen_id = this.props.poinPertanyaan.children.rows.jawaban_id;
        //             jawaban.pengguna_id = this.props.poinPertanyaan.children.rows.pengguna_id;
        //             jawaban.nilai = this.props.poinPertanyaan.children.rows.nilai;
                    
        //             this.props.kuesioner.rows.push(jawaban);
        //             this.props.kuesioner.total = this.props.kuesioner.rows.length;
        //         }
    
            }

        }

        
        // console.log(tmpIsian);

        this.setState({
            ...this.state,
            isian: {
                ...this.state.isian
            }
        //     // isian: {
        //         // ...this.state.isian,
        //         // ...tmpIsian
        //     // }
        },()=>{
            // console.log(this.state.isian);
        })

        // console.log(this.props.fetch);

        // this.setState({
        //     ...this.state,
        //     checkSelect: {
        //         "d4a0c2f8-14ab-4db9-9572-2bf02746983c" : !this.state.checkSelect["d4a0c2f8-14ab-4db9-9572-2bf02746983c"] 
        //     }
        // }, ()=>{
        //     console.log(this.state.checkSelect["d4a0c2f8-14ab-4db9-9572-2bf02746983c"]);
        // });

        let checkRadio = [];
        // console.log(this.state.kuesioner);
        for (let index = 0; index < this.props.kuesioner.rows.length; index++) {
            const element = this.props.kuesioner.rows[index];

            if(Number(element.tipe_instrumen_id) === 3 && Number(element.nilai) === 1){
                // console.log(element);
                checkRadio[element.ins_instrumen_id] = element.instrumen_id;
            }
        }

        this.setState({
            ...this.state,
            checkRadio: [
                ...this.state.checkRadio,
                ...checkRadio
            ],
            routeParams: {
                pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id,
                sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id,
                token: localStorage.getItem('jwt_token')
            }
        },()=>{
            // console.log(this.state.checkRadio.length);
        });

        if(this.props.konfirmasi_instrumen_id !== null){
            this.setState({
                ...this.state,
                kunci_konfirmasi_instrumen: true
            });
        }

        // console.log(this.props.poinPertanyaan);
        // if(Number(this.props.poinPertanyaan.a_pertanyaan) == 1){
        // }

        if(typeof this.props.kuesioner.rows.find(x => x.instrumen_id === this.props.poinPertanyaan.instrumen_id) !== 'undefined'){

            if(Number(this.props.kuesioner.rows.find(x => x.instrumen_id === this.props.poinPertanyaan.instrumen_id).nilai) === 1){
                // this.state.checkSelect[this.props.poinPertanyaan.instrumen_id] = true;
                this.setState({
                    checkSelect: {
                        ...this.state.checkSelect,
                        [this.props.poinPertanyaan.instrumen_id]: true
                    }
                })
            }else{
                // this.state.checkSelect[this.props.poinPertanyaan.instrumen_id] = false;
                this.setState({
                    checkSelect: {
                        ...this.state.checkSelect,
                        [this.props.poinPertanyaan.instrumen_id]: false
                    }
                })
            }

        }else{
            // this.state.checkSelect[this.props.poinPertanyaan.instrumen_id] = false;
            this.setState({
                checkSelect: {
                    ...this.state.checkSelect,
                    [this.props.poinPertanyaan.instrumen_id]: false
                }
            })
        }

    }

    // componentWillMount = () => {
    //     let checkRadio = [];
    //     for (let index = 0; index < this.props.kuesioner.rows.length; index++) {
    //         const element = this.props.kuesioner.rows[index];

    //         if(element.tipe_instrumen_id === 3 && element.nilai === 1){
    //             // console.log(element);
    //             checkRadio[element.ins_instrumen_id] = element.instrumen_id;
    //         }
    //     }

    //     this.setState({
    //         ...this.state,
    //         checkRadio: [
    //             ...this.state.checkRadio,
    //             ...checkRadio
    //         ]
    //     },()=>{
    //         // console.log(this.state.checkRadio.length);
    //     });
    // }

    // componentWillMount = () => {
    //     // this.setState({
    //     //     ...this.state,
    //     //     checkSelect: {
    //     //         "d4a0c2f8-14ab-4db9-9572-2bf02746983c" : !this.state.checkSelect["d4a0c2f8-14ab-4db9-9572-2bf02746983c"] 
    //     //     }
    //     // }, ()=>{
    //     //     console.log(this.state.checkSelect["d4a0c2f8-14ab-4db9-9572-2bf02746983c"]);
    //     // });
    //     this.state.checkSelect["d4a0c2f8-14ab-4db9-9572-2bf02746983c"] = true;
    // }

    render(){
        const {classes} = this.props;

        // console.log(this.props.radioCheck['3d351ccd-b471-4f92-a154-85d4b89ea5ca']);

        // console.log(this.props.poinPertanyaan);
        if(Number(this.props.poinPertanyaan.tingkat_instrumen_id) !== 6){
            return (
                <Card className={classes.panelPertanyaan}>
                    <CardHeader
                        subheader={"("+this.props.poinPertanyaan.induk+")"}
                        title={this.props.poinPertanyaan.nomor_urut + ". " +this.props.judul}
                        // className={classes.judulPertanyaan}
                        classes={{
                            title: classes.judulPertanyaan
                        }}
                    />
                    <CardContent style={{paddingTop: 0}}>
                        
                        {/* sub pertanyaan => jawaban */}
                        {Number(this.props.poinPertanyaan.a_pertanyaan) === 1 && 
                        <div>
                            {/* kalau tipenya checkbox */}
                            {Number(this.props.poinPertanyaan.tipe_instrumen_id) === 2 && 
                            <div>
                                
                                {this.props.poinPertanyaan.children.rows.map((option)=>{

                                    
                                    // console.log(option);
                                    // console.log(this.props.kuesioner.rows.find(x => x.instrumen_id === option.instrumen_id));
                                    
                                    
                                    //mengatur apakah diceklis atau tidak dari api
                                    // console.log(option);
                                    // console.log(this.props.kuesioner.rows);
                                    
                                    // if(option.jawaban_id !== null){

                                    //     // console.log(this.props.kuesioner.rows);

                                    //     // console.log('ada jawabannya');

                                        // this.state.checkSelect[option.instrumen_id] = true;

                                    //     for (let index = 0; index < this.props.kuesioner.rows.length; index++) {
                                    //         const element = this.props.kuesioner.rows[index];
                                            
                                    //         if(element.instrumen_id === option.instrumen_id){
                                    //             this.props.kuesioner.rows.splice(index, 1);
                                    //         }
                                            
                                    //     }

                                    //     let jawaban = {};
                                    //     // jawaban.ins_instrumen_id = event.currentTarget.ins_instrumen_id;
                                    //     // jawaban.induk_kode = event.currentTarget.induk_kode;
                                    //     jawaban.jawaban_id = option.jawaban_id;
                                    //     jawaban.instrumen_id = option.jawaban_id;
                                    //     jawaban.pengguna_id = option.pengguna_id;
                                    //     jawaban.nilai = option.nilai;
                                        
                                    //     this.props.kuesioner.rows.push(jawaban);
                                    //     this.props.kuesioner.total = this.props.kuesioner.rows.length;

                                        
                                    //     //     this.state.checkSelect[option.instrumen_id] = true;
                                        
                                    //     //     console.log(this.state);
                                    // }else{
                                    // console.log(this.props.kuesioner.rows.find(x => x.instrumen_id === option.instrumen_id));

                                    // setTimeout(() => {
                                    //     // console.log(this.props.kuesioner.rows);
                                    //     // console.log(option.instrumen_id);

                                    //     // for (let index = 0; index < this.props.kuesioner.rows.length; index++) {
                                    //     //     const element = this.props.kuesioner.rows[index];

                                    //     //     console.log(element.instrumen_id);
                                            
                                    //     // }
                                        
                                    // }, 5000);


                                    // }
                                    
                                    // console.log(this.props.kuesioner);
                                    
                                    // console.log(this.props.kuesioner.rows);
                                    // console.log(this.props.kuesioner.rows.find(x => x.instrumen_id === option.instrumen_id));
                                    if(typeof this.props.kuesioner.rows.find(x => x.instrumen_id === option.instrumen_id) !== 'undefined'){

                                        if(Number(this.props.kuesioner.rows.find(x => x.instrumen_id === option.instrumen_id).nilai) === 1){
                                            // this.state.checkSelect[option.instrumen_id] = true;
                                            this.setState({
                                                checkSelect: {
                                                    ...this.state.checkSelect,
                                                    [option.instrumen_id]: true
                                                }
                                            })
                                        }else{
                                            // this.state.checkSelect[option.instrumen_id] = false;
                                            this.setState({
                                                checkSelect: {
                                                    ...this.state.checkSelect,
                                                    [option.instrumen_id]: false
                                                }
                                            })
                                        }

                                    }else{
                                        // this.state.checkSelect[option.instrumen_id] = false;
                                        this.setState({
                                            checkSelect: {
                                                ...this.state.checkSelect,
                                                [option.instrumen_id]: false
                                            }
                                        })
                                        // this.setState({
                                        //     ...this.state,
                                        //     checkSelect: {
                                        //         ...this.state.checkSelect,
                                        //         [option.instrumen_id]: false
                                        //     }
                                        // });
                                    }

                                    return (
                                        <Paper className={classes.poinPilihan} key={option.instrumen_id}>
                                            <Grid container>
                                                <Grid item xs={12} sm={12} className={classes.borders}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={this.state.checkSelect[option.instrumen_id]}
                                                                onChange={this.checkboxTerpilih(option.ins_instrumen_id, option.induk_kode.substring(0,1), option.abstain)}
                                                                name={option.instrumen_id}
                                                                key={option.instrumen_id}
                                                                color="primary"
                                                                inputProps={{
                                                                    ins_instrumen_id: option.ins_instrumen_id,
                                                                    induk_kode: option.induk_kode.substring(0,1),
                                                                    abstain: option.abstain
                                                                }}
                                                                disabled={this.state.kunci_konfirmasi_instrumen}
                                                            />
                                                        }
                                                        label={option.judul}
                                                        className="wadahSelect"
                                                    />
                                                    {(Number(JSON.parse(localStorage.getItem('user')).peran_id) === 13 || Number(JSON.parse(localStorage.getItem('user')).peran_id) === 10) &&
                                                        <Paper className={"p-8 " + classes.panelPengawas} style={{width:'100%'}}>Dipilih oleh {option.jawaban_sekolah} responden</Paper>
                                                    }
                                                    {/* {option.instrumen_id} - {option.jawaban_id} */}
                                                </Grid>
                                                {Number(option.isian_bebas) === 1 && 
                                                <Grid item xs={12} sm={12} className={classes.borders}>
                                                    <TextField
                                                        id={"isian_"+option.instrumen_id}
                                                        label="........."
                                                        // disabled={this.state.isian['disabled_'+option.instrumen_id]}
                                                        // label={option.judul}
                                                        className={classes.textField}
                                                        value={this.state.isian["isian_"+option.instrumen_id]}
                                                        onChange={this.handleChange("isian_"+option.instrumen_id, option.instrumen_id, option.ins_instrumen_id)}
                                                        margin="dense"
                                                        style={{width: '100%'}}
                                                        variant="outlined"
                                                        disabled={this.state.kunci_konfirmasi_instrumen}
                                                    />
                                                    <Divider/>
                                                </Grid>}
                                            </Grid>
                                        </Paper>
                                    )

                                })}
                            </div>}
                            {/* kalau tipenya radio */}
                            {Number(this.props.poinPertanyaan.tipe_instrumen_id) === 3 && 
                            <RadioGroupFormsy
                            // className="my-16"
                            name={this.props.poinPertanyaan.instrumen_id}
                            value={this.state.checkRadio[this.props.poinPertanyaan.instrumen_id]}
                            required
                            >
                                {(Number(JSON.parse(localStorage.getItem('user')).peran_id) === 13 || Number(JSON.parse(localStorage.getItem('user')).peran_id) === 10) &&
                                    <Paper className="p-8" style={{width:'100%'}}>Pilihan mayoritas responden sekolah: <b>{this.props.poinPertanyaan.jawaban_sekolah}</b></Paper>
                                }
                                {this.props.poinPertanyaan.children.rows.map((optionJawaban)=>{

                                    for (let index = 0; index < this.props.kuesioner.rows.length; index++) {
                                        const element = this.props.kuesioner.rows[index];

                                        if(Number(element.tipe_instrumen_id) === 3 && Number(element.nilai) === 1){
                                            // console.log(element);
                                            // this.state.checkRadio[element.ins_instrumen_id] = element.instrumen_id;
                                            this.setState({
                                                checkRadio: {
                                                    ...this.state.checkRadio,
                                                    [element.ins_instrumen_id]: element.instrumen_id
                                                }
                                            })
                                        }

                                    }

                                    // console.log(this.state.checkRadio);

                                    // console.log(this.props.checkRadio[this.props.poinPertanyaan.instrumen_id]);
                                    return(
                                        <FormControlLabel 
                                            className="radioKuesioner" 
                                            value={optionJawaban.instrumen_id} 
                                            key={optionJawaban.instrumen_id} 
                                            control={<Radio color="primary"/>} 
                                            label={optionJawaban.judul}
                                            onChange={this.radioTerpilih}   
                                            disabled={this.state.kunci_konfirmasi_instrumen}
                                        />
                                    )
                                })}
                            </RadioGroupFormsy>}
                        </div>}

                        {/* sub pertanyaan => sub sub pertanyaan */}
                        {Number(this.props.poinPertanyaan.a_pertanyaan) !== 1 && 
                        <Grid container spacing={16}>
                            {this.props.poinPertanyaan.children.rows.map((optionSubSub)=>{
                                // console.log(this.state.checkRadio);
                                // console.log(optionSubSub.instrumen_id);
                                return(
                                <Grid item xs={12} sm={6} key={optionSubSub.instrumen_id}>
                                    <Card>
                                        <CardHeader
                                            title={optionSubSub.judul}
                                            classes={{
                                                title: classes.judulSubSub,
                                                root: classes.kontenJudulSubSub
                                            }}
                                        />
                                        <CardContent className={classes.kontenSubSub}>
                                            {/* tipe radiobox */}
                                            {Number(optionSubSub.tipe_instrumen_id) === 3 && 
                                            <RadioGroupFormsy
                                            className="my-16"
                                            name={optionSubSub.instrumen_id}
                                            // value={value}
                                            value={this.state.checkRadio[optionSubSub.instrumen_id]}
                                            required
                                            >
                                                {(Number(JSON.parse(localStorage.getItem('user')).peran_id) === 13 || Number(JSON.parse(localStorage.getItem('user')).peran_id) === 10) &&
                                                    <Paper className={"p-8 " + classes.panelPengawas} style={{width:'100%'}}>Pilihan mayoritas responden sekolah: <b>{optionSubSub.jawaban_sekolah}</b></Paper>
                                                }
                                                {optionSubSub.children.rows.map((optionSubSubJawaban)=>{
                                                    
                                                    // for (let index = 0; index < this.props.kuesioner.rows.length; index++) {
                                                    //     const element = this.props.kuesioner.rows[index];
                
                                                    //     if(element.tipe_instrumen_id === 3 && element.nilai === 1){
                                                    //         // console.log(element);
                                                    //         this.state.checkRadio[element.ins_instrumen_id] = element.instrumen_id;
                                                    //     }
    
                                                    // }
                                                    for (let index = 0; index < this.props.kuesioner.rows.length; index++) {
                                                        const element = this.props.kuesioner.rows[index];
                
                                                        if(Number(element.tipe_instrumen_id) === 3 && Number(element.nilai) === 1){
                                                            // console.log(element);
                                                            // this.state.checkRadio[element.ins_instrumen_id] = element.instrumen_id;
                                                            this.setState({
                                                                checkRadio: {
                                                                    ...this.state.checkRadio,
                                                                    [element.ins_instrumen_id]: element.instrumen_id
                                                                }
                                                            })
                                                        }
                
                                                    }

                                                    // console.log(this.state.checkRadio);
                                                    
                                                return(
                                                    <FormControlLabel 
                                                        className="radioKuesioner" 
                                                        value={optionSubSubJawaban.instrumen_id} 
                                                        key={optionSubSubJawaban.instrumen_id} 
                                                        control={<Radio color="primary"/>} 
                                                        label={optionSubSubJawaban.judul}
                                                        onChange={this.radioTerpilih}
                                                        disabled={this.state.kunci_konfirmasi_instrumen}
                                                    />
                                                )})}
                                            </RadioGroupFormsy>}
                                            {/* tipe checkbox */}
                                            {Number(optionSubSub.tipe_instrumen_id) === 2 && 
                                            <div>
                                                {optionSubSub.children.rows.map((optionSubSubJawaban)=>{
                                                if(typeof this.props.kuesioner.rows.find(x => x.instrumen_id === optionSubSubJawaban.instrumen_id) !== 'undefined'){

                                                    if(Number(this.props.kuesioner.rows.find(x => x.instrumen_id === optionSubSubJawaban.instrumen_id).nilai) === 1){
                                                        // this.state.checkSelect[optionSubSubJawaban.instrumen_id] = true;
                                                        this.setState({
                                                            checkSelect: {
                                                                ...this.state.checkSelect,
                                                                [optionSubSubJawaban.instrumen_id]: true
                                                            }
                                                        })
                                                    }else{
                                                        // this.state.checkSelect[optionSubSubJawaban.instrumen_id] = false;
                                                        this.setState({
                                                            checkSelect: {
                                                                ...this.state.checkSelect,
                                                                [optionSubSubJawaban.instrumen_id]: false
                                                            }
                                                        })
                                                    }
            
                                                }else{
                                                    // this.state.checkSelect[optionSubSubJawaban.instrumen_id] = false;
                                                    this.setState({
                                                        checkSelect: {
                                                            ...this.state.checkSelect,
                                                            [optionSubSubJawaban.instrumen_id]: false
                                                        }
                                                    })
                                                }
                                                return(
                                                <Paper className={classes.poinPilihan} key={optionSubSubJawaban.instrumen_id}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={this.state.checkSelect[optionSubSubJawaban.instrumen_id]}
                                                                onChange={this.checkboxTerpilih(optionSubSubJawaban.ins_instrumen_id, optionSubSubJawaban.induk_kode.substring(0,1), optionSubSubJawaban.abstain)}
                                                                name={optionSubSubJawaban.instrumen_id}
                                                                key={optionSubSubJawaban.instrumen_id}
                                                                color="primary"
                                                                inputProps={{
                                                                    ins_instrumen_id: optionSubSubJawaban.ins_instrumen_id,
                                                                    induk_kode: optionSubSubJawaban.induk_kode.substring(0,1),
                                                                    abstain: optionSubSubJawaban.abstain
                                                                }}
                                                                disabled={this.state.kunci_konfirmasi_instrumen}
                                                            />
                                                        }
                                                        label={optionSubSubJawaban.judul}
                                                        className="wadahSelect"
                                                    />
                                                    {(Number(JSON.parse(localStorage.getItem('user')).peran_id) === 13 || Number(JSON.parse(localStorage.getItem('user')).peran_id) === 10) &&
                                                        <Paper className={"p-8 " + classes.panelPengawas} style={{width:'100%'}}>Dipilih oleh {optionSubSubJawaban.jawaban_sekolah} responden</Paper>
                                                    }
                                                    {Number(optionSubSubJawaban.isian_bebas) === 1 && 
                                                    <Grid item xs={12} sm={12} className={classes.borders}>
                                                        <TextField
                                                            id={"isian_"+optionSubSubJawaban.instrumen_id}
                                                            label="........."
                                                            // disabled
                                                            // disabled={this.state.isian['disabled_'+optionSubSubJawaban.instrumen_id]}
                                                            // label={optionSubSubJawaban.judul}
                                                            className={classes.textField}
                                                            value={this.state.isian["isian_"+optionSubSubJawaban.instrumen_id]}
                                                            onChange={this.handleChange("isian_"+optionSubSubJawaban.instrumen_id, optionSubSubJawaban.instrumen_id, optionSubSubJawaban.ins_instrumen_id)}
                                                            margin="dense"
                                                            style={{width: '100%'}}
                                                            variant="outlined"
                                                            disabled={this.state.kunci_konfirmasi_instrumen}
                                                        />
                                                        <Divider/>
                                                    </Grid>}
                                                </Paper>
                                                )})}
                                            </div>} 
                                        </CardContent>
                                    </Card>
                                </Grid>   
                            )})}
                        </Grid>}
                    </CardContent>
                </Card>
            )
        }else{


            // // // ini yang dikomen
            // if(typeof this.props.kuesioner.rows.find(x => x.instrumen_id === this.props.poinPertanyaan.instrumen_id) !== 'undefined'){

            //     if(Number(this.props.kuesioner.rows.find(x => x.instrumen_id === this.props.poinPertanyaan.instrumen_id).nilai) === 1){
            //         // this.state.checkSelect[this.props.poinPertanyaan.instrumen_id] = true;
            //         this.setState({
            //             checkSelect: {
            //                 ...this.state.checkSelect,
            //                 [this.props.poinPertanyaan.instrumen_id]: true
            //             }
            //         })
            //     }else{
            //         // this.state.checkSelect[this.props.poinPertanyaan.instrumen_id] = false;
            //         this.setState({
            //             checkSelect: {
            //                 ...this.state.checkSelect,
            //                 [this.props.poinPertanyaan.instrumen_id]: false
            //             }
            //         })
            //     }

            // }else{
            //     // this.state.checkSelect[this.props.poinPertanyaan.instrumen_id] = false;
            //     this.setState({
            //         checkSelect: {
            //             ...this.state.checkSelect,
            //             [this.props.poinPertanyaan.instrumen_id]: false
            //         }
            //     })
            // }

            // console.log(this.props.poinPertanyaan)

            return (
                <Paper className={classes.poinPilihan}>
                    {Number(this.props.tipeInduk) === 2 && 
                    // {Number(this.props.poinPertanyaan.tipe_instrumen_id) === 2 && 
                    <div>
                        {Number(this.props.poinPertanyaan.isian_bebas) !== 1 && 
                        <FormControlLabel
                            control={
                                <Checkbox
                                defaultChecked={this.props.poinPertanyaan.jawaban_id ? (parseInt(this.props.poinPertanyaan.nilai) === 1 ? true : false) : false}
                                // checked={this.state.checkSelect[this.props.poinPertanyaan.instrumen_id]}
                                onChange={this.checkboxTerpilih(this.props.poinPertanyaan.ins_instrumen_id, this.props.poinPertanyaan.induk_kode.substring(0,1), this.props.poinPertanyaan.abstain)}
                                name={this.props.poinPertanyaan.instrumen_id}
                                key={this.props.poinPertanyaan.instrumen_id}
                                color="primary"
                                inputProps={{
                                    ins_instrumen_id: this.props.poinPertanyaan.ins_instrumen_id,
                                    induk_kode: this.props.poinPertanyaan.induk_kode.substring(0,1),
                                    abstain: this.props.poinPertanyaan.abstain
                                }}
                                disabled={this.state.kunci_konfirmasi_instrumen}
                                />
                            }
                            label={this.props.poinPertanyaan.judul}
                            className="wadahSelect"
                        />
                        }
                        {Number(this.props.poinPertanyaan.isian_bebas) === 1 && 
                        // <Grid item xs={12} sm={12} className={classes.borders}>
                            <TextField
                                id={"isian_"+this.props.poinPertanyaan.instrumen_id}
                                label="........."
                                // disabled={this.state.isian['disabled_'+this.props.poinPertanyaan.instrumen_id]}
                                // label={this.props.poinPertanyaan.judul}
                                className={classes.textField}
                                // value={this.state.isian["isian_"+this.props.poinPertanyaan.instrumen_id]}
                                defaultValue={this.props.poinPertanyaan.isian}
                                onChange={this.handleChange("isian_"+this.props.poinPertanyaan.instrumen_id, this.props.poinPertanyaan.instrumen_id, this.props.poinPertanyaan.ins_instrumen_id)}
                                margin="dense"
                                style={{width: '100%'}}
                                variant="outlined"
                                disabled={this.state.kunci_konfirmasi_instrumen}
                            />
                            // <Divider/>
                        // </Grid>
                        }
                        {/* {(Number(JSON.parse(localStorage.getItem('user')).peran_id) === 13 || Number(JSON.parse(localStorage.getItem('user')).peran_id) === 10) &&
                            <Paper className={"p-8 " + classes.panelPengawas} style={{width:'100%'}}>Dipilih oleh {this.props.poinPertanyaan.jawaban_sekolah} responden</Paper>
                        } */}
                    </div>
                    }
                    {this.props.tipeInduk === 3 &&
                    // {this.props.poinPertanyaan.tipe_instrumen_id === 3 &&
                        <FormControlLabel 
                        className="radioKuesioner" 
                        value={this.props.poinPertanyaan.instrumen_id} 
                        key={this.props.poinPertanyaan.instrumen_id} 
                        control={<Radio color="primary"/>} 
                        label={this.props.poinPertanyaan.judul}
                        onChange={this.radioTerpilih}
                        disabled={this.state.kunci_konfirmasi_instrumen}
                        />
                    } 
                </Paper>
            )
        }
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setKuesioner: Actions.setKuesioner,
        getKuesioner: Actions.getKuesioner,
        setKuesionerDirty: Actions.setKuesionerDirty,
        setRadioKuesioner : Actions.setRadioKuesioner,
        setKunciKonfirmasiInstrumen: Actions.setKunciKonfirmasiInstrumen,
        getKonfirmasiSelesai: Actions.getKonfirmasiSelesai
    }, dispatch);
}

function mapStateToProps({ Instrumen }) {

    // console.log(Instrumen.kuesioner);

    return {
        kuesioner: Instrumen.kuesioner,
        fetch_kuesioner: Instrumen.fetch_kuesioner,
        checkSelect: Instrumen.checkSelect,
        checkRadio: Instrumen.checkRadio,
        dirty: Instrumen.dirty,
        radioCheck: Instrumen.radioCheck,
        konfirmasi_instrumen: Instrumen.konfirmasi_instrumen,
        konfirmasi_instrumen_id: Instrumen.konfirmasi_instrumen_id
    }
}

// export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(RaporSPMSekolah)));
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(PanelPertanyaan)));





// WEBPACK FOOTER //
// ./src/main/content/Instrumen/PanelPertanyaan.js